import { selectCompanies } from '@modules/admin/Admin.Dux'
import React, { useState } from 'react'
import { Trans } from 'react-i18next'
import { useSelector } from 'react-redux'
import Consultations from '../../../Services/Consultations'
import AccessControl from '../../auth/AccessControl'
import Loading from '../../core/components/Loading'
import { DashboardHeader } from '../Admin.Header'
import { CompanyTable } from './Company.Table'
import CompanyGroupModal from '@modules/admin/companies/Company.Group.Modal'
import CompanyCreateModal from '@modules/admin/companies/CompanyCreateModal/CompanyCreateModal'
import history from '@services/History'

const CompaniesIndex = () => {
  const [total] = useState(0)
  // const [companies,setCompanies]=useState(null);
  const [showGroupsModal, setShowGroupsModal] = useState(null)
  const [showCreateModal, setShowCreateModal] = useState(null)

  const companies = useSelector((state) => selectCompanies(state))

  const handleCreateCompany = async (values) => {
    try {
      const { data } = await Consultations.company.store(values)
      setShowCreateModal(false)
      history.push(`/companies/update/${data?.id}`)
    } catch (e) {
      console.error(e.messsage)
    }
  }
  return (
    <>
      <DashboardHeader title={<Trans>Compañías</Trans>} total={total}>
        <AccessControl requiredRole="provider">
          <button onClick={() => history.push('/companies/create')} className="btn btn-primary">
            <Trans>Crear</Trans>
          </button>
        </AccessControl>
      </DashboardHeader>
      <Loading isFetching={!companies} />
      {showCreateModal && <CompanyCreateModal hide={() => setShowCreateModal(false)} onSubmit={handleCreateCompany} />}
      {showGroupsModal && <CompanyGroupModal company={showGroupsModal} hide={() => setShowGroupsModal(null)} />}
      {companies && (
        <CompanyTable
          companies={companies}
          emptyText={'No existen compañías'}
          actionLink={'companies'}
          showGroupModal={(company) => setShowGroupsModal(company)}
        />
      )}
    </>
  )
}
export default CompaniesIndex
// const mapStateToProps = (state) => ({
//   companies: selectCompanies(state),
// });
// export default withTranslation()(connect(mapStateToProps)(CompaniesIndex));
